import moment from "moment-timezone";
import {
	buildOccupiedByTableForAssignment,
	listMoveTableOptions,
	FORMATS,
} from "@lib/common";
import { RootStore } from "../../../../../mobx/store";

/**
 * Valid table options (free in the turn window, enough seats) for admin modals.
 * Includes joined table combos when floor layout or explicit links allow them.
 */
export async function loadDashboardBookingTableOptions(
	store: RootStore,
	args: {
		restaurantId: string;
		timezone: string;
		timestamp: number;
		turnMinutes: number;
		party: number;
	}
): Promise<Array<{ table_ids: string[]; label: string }>> {
	const r = store.restaurant;
	if (!r) return [];
	const tables = r.settings.services?.dine_in?.tables || [];
	if (!tables.length) return [];

	const tz = args.timezone;
	const m = moment(args.timestamp).tz(tz);
	const dayStart = m.clone().startOf("day").valueOf();
	const dayEnd = m.clone().endOf("day").valueOf();

	const response = await store.api.bookings_find({
		page: 1,
		limit: 500,
		sort: { "config.timestamp": 1 },
		query: {
			restaurant_id: args.restaurantId,
			"config.timestamp": { $gte: dayStart, $lte: dayEnd },
		},
	});
	if (response.outcome !== 0) {
		return [];
	}

	const turn = Math.max(15, args.turnMinutes);
	const window = {
		start: args.timestamp,
		end: args.timestamp + turn * 60_000,
	};
	const dayDateStr = m.format(FORMATS.moment.date);
	const tableBlocks = r.settings.services?.table_booking?.table_blocks;
	const occupied = buildOccupiedByTableForAssignment(
		response.items,
		tableBlocks,
		turn,
		tz,
		dayDateStr
	);
	return listMoveTableOptions(
		tables,
		args.party,
		window,
		occupied,
		4,
		false
	);
}
